import axios from 'axios';
import { BalancaMarcaModelo } from '@models/balanca-marca-modelo.model';

const lista = async (): Promise<BalancaMarcaModelo[]> => {
  const res = await axios.get<BalancaMarcaModelo[]>(`/balancas_marca_modelo`);
  return res.data;
};

export default {
  lista,
};
